import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

export const CANCEL_INBOUND_SUBSCRIPTION = gql(`
  mutation CANCEL_INBOUND_SUBSCRIPTION($subscriptionId: ID!) {
    subscriptionCancelInbound(subscriptionId: $subscriptionId) {
      ... AppSubscriptionCancel
    }
  }
`);

export const useCancelInboundSubscription = () =>
  useMutation(CANCEL_INBOUND_SUBSCRIPTION);
